<!-- hospital.component.html -->
<p-toast></p-toast>

<div class="card">
  <h2>Registro de Institución</h2>
  
  <form [formGroup]="institucionForm" (ngSubmit)="onSubmit()">
    <div class="p-fluid p-formgrid p-grid">
      
      <!-- Nombre Hospital -->
      <div class="p-field p-col-12 p-md-6">
        <label for="nomInstitucion">Nombre de la Institución</label>
        <input 
          id="nomInstitucion"
          type="text"
          pInputText
          formControlName="nomInstitucion"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          [ngClass]="{'ng-invalid ng-dirty': f['nomInstitucion'].touched && f['nomInstitucion'].errors}">
        <small class="p-error" *ngIf="f['nomInstitucion'].touched && f['nomInstitucion'].errors?.['required']">
          El nombre del Institución es requerido
        </small>
        <small class="p-error" *ngIf="f['nomInstitucion'].touched && f['nomInstitucion'].errors?.['minlength']">
          El nombre debe tener al menos 3 caracteres
        </small>
      </div>

      <!-- Clave Institución -->
      <div class="p-field p-col-12 p-md-6">
        <label for="cvInstitucion">Abreviacion de Institución</label>
        <input 
          id="cvInstitucion"
          type="text"
          pInputText
          formControlName="cvInstitucion"
          class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary"
          [ngClass]="{'ng-invalid ng-dirty': f['cvInstitucion'].touched && f['cvInstitucion'].errors}">
        <small class="p-error" *ngIf="f['cvInstitucion'].touched && f['cvInstitucion'].errors?.['required']">
           La abreviacion de la institución es requerida
        </small>
        <small class="p-error" *ngIf="f['cvInstitucion'].touched && f['cvInstitucion'].errors?.['minlength']">
            El abreviacion debe tener al menos 2 caracteres
        </small>
      </div>    
      
    </div>
     <!-- Botones -->
     <div class="field col-12 md:col-4">
        <p-button 
        type="submit"
        label="Guardar"
        icon="pi pi-save"
        [disabled]="institucionForm.invalid">
      </p-button>
    </div> 
    
  </form>
</div>
